import React, { useContext } from "react";
import {
  Box,
  Typography,
  Divider,
  Breadcrumbs,
  Link,
  Tabs,
  Tab,
  makeStyles,
} from "@material-ui/core";
import { ViewWinnerContext } from "../../contexts/ViewWinnerContext";
import { getLang } from "app/feature/constants";
import { NavigateNext as NavigateNextIcon } from "@material-ui/icons";
import ViewWinnerMetricsPanel from "../../components/panel/viewWinnerMetricsPanel";
import ViewWinnerFilterPanel from "../../components/panel/viewWinnerFilterPanel";
import ViewWinnerDetailsTable from "../../components/table/viewWinnerDetailsTable";
import AdminActionDialog from "../../components/dialog/adminActionDialog";
import BulkProcessDialog from "../../components/dialog/bulkProcessDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  breadcrumb: {
    fontSize: "0.875rem",
  },
  breadcrumbLink: {
    color: theme.palette.text.secondary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  breadcrumbActive: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: "bold",
  },
  tabsContainer: {
    marginBottom: theme.spacing(2),
  },
  tab: {
    textTransform: "none",
    fontWeight: 600,
    minWidth: 120,
  },
}));

export default function ViewTranditionalRaffleWinnerPageComponent() {
  const classes = useStyles();
  const { lang, activeTab, handleTabChange, handleBack, isClaimListView } =
    useContext(ViewWinnerContext);

  return (
    <Box className={classes.root}>
      {/* Breadcrumb Navigation */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className={classes.breadcrumb}
      >
        <Link
          className={classes.breadcrumbLink}
          onClick={() => (window.location.href = "/lucky-draw-v2")}
        >
          {getLang(lang, "label.LUCKY_DRAW")}
        </Link>
        <Link className={classes.breadcrumbLink} onClick={handleBack}>
          {getLang(lang, "label.TRADITIONAL_RAFFLE")}
        </Link>
        <Typography className={classes.breadcrumbActive}>
          {isClaimListView ? getLang(lang, "label.VIEW_CLAIM_LIST") : getLang(lang, "label.VIEW_WINNERS")}
        </Typography>
      </Breadcrumbs>

      <Box my={2}>
        <Divider />
      </Box>

      {/* Key Metrics */}
      <ViewWinnerMetricsPanel />

      {/* Tabs */}
      <Box className={classes.tabsContainer}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            label={getLang(lang, "label.TO_PROCESS")}
            className={classes.tab}
          />
          <Tab
            label={getLang(lang, "label.UNCLAIMED_PRIZE")}
            className={classes.tab}
          />
        </Tabs>
      </Box>

      <Divider />

      {/* Filter Panel */}
      <ViewWinnerFilterPanel />

      {/* Winner Details Table */}
      <ViewWinnerDetailsTable />

      {/* Admin Action Dialog */}
      <AdminActionDialog />

      {/* Bulk Process Dialog */}
      <BulkProcessDialog />
    </Box>
  );
}
